<template>
  <div>
    <about-species />
    <ocurrence-map />
    <nature-lynx-sightings />
  </div>
</template>
<script>
import AboutSpecies from './AboutSpecies.vue';
import OcurrenceMap from './OcurrenceMap.vue';
import NatureLynxSightings from './NatureLynxSightings.vue'

export default {
  components: { AboutSpecies, OcurrenceMap, NatureLynxSightings },
  name: 'overview-tab'

}
</script>
